import React, { useCallback, useContext, useEffect } from 'react'
import { PerformAssessmentStyles } from './Style'
import { PerformAssessmentContext } from './PerformAssessmentContext'
import { performAssessmentHooks, TooltipMessage } from '.'
import { Button } from 'components/Form'
import { Fab } from '@mui/material'
import { QuestionMark } from '@mui/icons-material'
import AssessmentDetails from '../Assessment/AssessmentDetails'

const PerformAssessment = () => {
    const { canvasRef, tooltipOpen, setTooltipOpen, stopRecord, startRecord, currentStep, isRecording, assessmentDef } = useContext(PerformAssessmentContext)

    const steps = performAssessmentHooks.useSteps()

    const Component = steps[currentStep].component

    const tooltip = steps[currentStep].tooltip?.[assessmentDef?.category_name] || steps[currentStep].tooltip || ""

    const handleTooltip = useCallback(() => {
        setTooltipOpen(!tooltipOpen)
        setTimeout(() => {
            setTooltipOpen(false)
        }, 6000);
    }, [tooltipOpen])

    return (
        <PerformAssessmentStyles>
            {tooltipOpen &&
                <div className='description-tooltip'>
                    <div className='tooltip-corner'></div>
                    {tooltip}
                </div>}
            <div className='tooltip-fab'>
                <Fab color="light" aria-label="edit" onClick={handleTooltip}>
                    <QuestionMark color="gray" />
                </Fab>
            </div>
            <div className='perform-assessment-header'>
                <div className='wrap-waves-and-button'>
                    <div className='wrap-play-pause'>
                        {currentStep == 3 && <Button size="small" color="gray" label={isRecording ? "הפסק הקלטה" : "המשך הקלטה"} action={isRecording ? stopRecord : startRecord} />}
                    </div>
                    <div style={{ height: 32, width: 100 }}>
                        <canvas className={isRecording && 'waves'} ref={canvasRef} width={100} height={32}></canvas>
                    </div>
                </div>
                <div className='wrap-assessment-details'>
                    <AssessmentDetails />
                </div>
            </div>
            <Component />
        </PerformAssessmentStyles>
    )
}

export default PerformAssessment